<template>
  <div>
    <b-table
      ref="table"
      :items="invoice.lines"
      :fields="fields"
      :class="{ loaded: !gettingInvoice }"
      show-empty
      responsive
    >
      <template #table-caption>
        <div class="d-flex flex-column w-100 px-1">
          <div class="ml-auto d-flex">
            <div class="d-flex flex-column text-right">
              <label>Subtotal</label>
              <label v-if="coupon.percentOff !== 0">{{
                `${coupon.name} (${coupon.percentOff}% off)`
              }}</label>
              <label
                v-if="coupon.amountOff !== 0"
              >{{ coupon.name }} (Amount off)</label>
              <label>Total</label>
            </div>
            <div class="d-flex flex-column total-price">
              <label>{{ currencySymbol }}{{ calcPrice(invoice.subtotal) }}</label>
              <label
                v-if="coupon.percentOff !== 0"
              >-{{ currencySymbol }}{{ percentOff }}</label>
              <label
                v-if="coupon.amountOff !== 0"
              >-{{ calcPrice(coupon.amountOff) }}</label>
              <label>{{ currencySymbol }}{{ calcPrice(invoice.total) }}</label>
            </div>
          </div>
        </div>
      </template>

      <template #cell(quantity)="data">
        {{ data.value.toLocaleString() }}
      </template>

      <template #cell(unitPrice)="data">
        {{ currencySymbol }}{{ (data.value / 100).toLocaleString() }}
      </template>

      <template #cell(total)="data">
        {{ currencySymbol }}{{ (data.value / 100).toLocaleString() }}
      </template>

      <template #cell(nickname)="data">
        <div class="d-flex">
          {{ data.value }}
          <div class="d-lg-none ml-auto">
            <a
              v-b-tooltip.hover.v-primary="data.item.description"
              v-b-tooltip.click.v-primary="data.item.description"
            >
              <GjIcon name="Info" />
            </a>
          </div>
        </div>
      </template>
      <template #empty>
        <transition
          name="fade"
          mode="out-in"
        >
          <div
            v-if="gettingInvoice"
            class="loading-table text-center py-3"
          >
            <b-spinner variant="primary" />
          </div>
          <div
            v-else
            class="d-flex justify-content-center align-items-center"
            style="height: 220px"
          >
            No records.
          </div>
        </transition>
      </template>
    </b-table>
    <table-busy v-if="gettingInvoice" />
  </div>
</template>
<script>
export default {
  name: 'InvoiceTable',
  props: {
    invoice: {
      type: Object,
      required: true,
    },
    gettingInvoice: {
      type: Boolean,
      required: true,
    },
    currencySymbol: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        { key: 'nickname', label: 'Type' },
        {
          key: 'description',
          thClass: 'd-none d-lg-table-cell',
          tdClass: 'd-none d-lg-table-cell',
        },
        { key: 'quantity', label: 'Qty', tdClass: 'text-right' },
        { key: 'unitPrice', tdClass: 'text-right' },
        { key: 'total', tdClass: 'text-right', variant: 'price' },
      ],
    }
  },
  computed: {
    coupon() {
      return this.invoice.coupon ? this.invoice.coupon : {}
    },
    percentOff() {
      const percentage = (this.coupon.percentOff / 100) * this.invoice.subtotal
      return this.calcPrice(percentage)
    },
  },
  methods: {
    calcPrice(val) {
      return (val / 100).toLocaleString()
    },
  },
}
</script>
<style lang="scss" scoped>
.total-price {
  min-width: 60px;
  text-align: right;
}
</style>
